import {overlayHtml} from "../../overlayHtml";

export class BabyNumber extends overlayHtml {
  private position;
  private view;
  // private objectPosition;
  private babyVal;
  private anchor;
  public isCreated = false;
  private currentChangeListener = null;
  private positionType = null;
  private isDisabledLabel = false;
  private style = null;

  private _margins = [];
  set margin(val:any[]){
    this._margins = val;
  }
  get margin(){
    return this._margins;
  }
  private _fixedPositions = {};
  set fixedPositions(val:object){
    this._fixedPositions = val;
  }
  get fixedPositions(){
    return this._fixedPositions;
  }

  get isOverlayDisabled(){
    return this.isDisabledLabel;
  }

  constructor(view, id, position, input) {
    super(id);
    // this.object = object;
    this.position = position;
    this.view = view;
    this.initPropsFromInput(input);

    if (!window['CANVAS_LABELS_ALLOWED']) {
      this.createOverlay();
    }

    this.createBabyNumber(input.anchor);
    this.setStyle(input.style);
    this.setBabyNumber(input.value);
  }

  public setStyle(style) {
    this.style = style;
  }

  public setLabelDisabledValue(flag){
    this.isDisabledLabel = flag;
     (flag) ? this.hideBabyNumber() : this.showBabyNumber();
  }

  public setOverlayStyles(stylesStr) {
    if (!window['CANVAS_LABELS_ALLOWED']) {
      super.setOverlayStyles(stylesStr);
    }

    // console.log('[CANVAS LABELS] setOverlayStyles');
    this.managerSetItem(true);
  }

  private initPropsFromInput(input) {
    this.positionType = input.hasOwnProperty('mapLabelPositionType') ? input['mapLabelPositionType'] : 'px';
    this.margin = input.hasOwnProperty('mapLabelMargins') ? input['mapLabelMargins'] : [0,0];
    this.fixedPositions = input.hasOwnProperty('mapLabelPosition') ? input['mapLabelPosition'] : {};
  }

  public setBabyNumber(value) {
    if (value && value.length > 0) {
      this.babyVal = value;

      if (!window['CANVAS_LABELS_ALLOWED']) {
        this.view.changeTextOverlayContent(this.overlay, value.toString());
        this.calculateBabyNumberPosition();
      }

      this.showBabyNumber();
    } else {
      this.babyVal = null;

      if (!window['CANVAS_LABELS_ALLOWED']) {
        this.view.changeTextOverlayContent(this.overlay, '');
      }

      this.hideBabyNumber();
    }
  }

  private calculateBabyNumberPosition(){
    if (!window['CANVAS_LABELS_ALLOWED']) {
      this.view.addBabyOverlayPositionEventListener(this.overlay, this.position, this.view.getOffsetByAnchor(this.anchor));
    }
  }

  removeBabyNumber(){
    if (!window['CANVAS_LABELS_ALLOWED']) {
      this.view.removeTextOverlay(this.overlay);
    }
    this.babyVal = '';
    this.managerDeleteItem();
  }

  overlayChangePosition(position){
    this.position = position;
    if (!window['CANVAS_LABELS_ALLOWED']) {
      this.view.changeBabyOverlayPosition(this.currentChangeListener, this.overlay, position, {
        anchor: this.anchor,
        positionType: this.positionType,
        margin: this.margin,
        fixedPositions: this.fixedPositions
      });
    }

    // this.view.customUpdateRenderer();
    this.view.raiseCameraEvent('moveEnd');

    // console.log('[CANVAS LABELS] overlayChangePosition');
    this.managerSetItem(true);
  }

  createBabyNumber(anchor){
    this.anchor = anchor;

    if (!window['CANVAS_LABELS_ALLOWED']) {
      this.currentChangeListener = this.view.createBabyOverlay(this.overlay, this.position, {
        anchor: this.anchor,
        positionType: this.positionType,
        margin: this.margin,
        fixedPositions: this.fixedPositions
      });
    }

    this.isCreated = true;
  }

  changeBabyAnchor(val){
    this.anchor = val;

    if (!window['CANVAS_LABELS_ALLOWED']) {
      this.currentChangeListener = this.view.changeBabyOverlayAnchor(this.overlay, this.position, {
        anchor: this.anchor,
        positionType: this.positionType,
        margin: this.margin,
        fixedPositions: this.fixedPositions
      });
    }

    this.view.raiseCameraEvent('moveEnd');

    // console.log('[CANVAS LABELS] changeBabyAnchor');
    this.managerSetItem(true);
  }

  showBabyNumber(){
    console.log('this.isDisabledLabel', this.isDisabledLabel);
    if (!this.isDisabledLabel){
      if (!window['CANVAS_LABELS_ALLOWED']) {
         this.view.showBabyOverlay(this.overlay);
      }
      // console.log('[CANVAS LABELS] showBabyNumber');
      this.managerSetItem();
    }
  }

  hideBabyNumber(){
    if (!window['CANVAS_LABELS_ALLOWED']) {
      this.view.hideBabyOverlay(this.overlay);
    }

    this.managerHideItem();
  }

  private managerSetItem(onlyIfExist = false) {
    if (window['CANVAS_LABELS_ALLOWED']) {
      if (onlyIfExist && !this.view.itemsManager.hasItem(this.id)) {
        return;
      }

      this.view.itemsManager.setItem(this.getConfig());
    }
  }

  private managerHideItem() {
    if (window['CANVAS_LABELS_ALLOWED']) {
      this.view.itemsManager.hideItemByValue(this.getConfig());
    }
  }

  private managerDeleteItem() {
    if (window['CANVAS_LABELS_ALLOWED']) {
      this.view.itemsManager.deleteItemByValue(this.getConfig());
    }
  }

  private getConfig() {
    return {
      id: this.id,
      position: this.position,
      anchor: this.anchor,
      value: this.babyVal,
      style: this.style,
    };
  }
}
